export default from './stripIndent';
